import Comparison from './Comparison';

export default Comparison;
